import { requestApi } from '../util/network'
// 获取货币列表
export const getCurrencyList =
() =>
  requestApi(
    '/Membercurrency/currency_list',
    'POST',
    {

    },
    'member'
  )
// 获取单条货币信息
export const getCurrencyInfo =
    () =>
      requestApi(
        '/Membercurrency/currency_info',
        'POST',
        {

        },
        'member'
      )
// 变更货币
export const editCurrency =
    (currency) =>
      requestApi(
        '/Membercurrency/currency_edit',
        'POST',
        {
          'currency': currency
        },
        'member'
      )
